<div id="sky-coins02" class="p-sky-coins__item p-sky-coins__item--payment p-sky-coin-summary__wapper is-open">
  <div class="p-sky-coins__row">
    <div class="p-sky-coins__row-item">
      <!-- 支払内訳 -->
      <div class="p-sky-coins__row-head" [innerHTML]="'label.paymentWithskycoin' | staticMsg"></div>
      <div class="p-sky-coins__row-body">
        <div class="p-sky-coins__payment">
          <div class="p-sky-coins__payment-body">
            <dl class="c-flex-list01">
              <!-- お支払い総額 -->
              <div class="c-flex-list01__item c-flex-list01__item--sb c-flex-list01__item--center">
                <dt class="c-flex-list01__title">
                  <span
                    class="p-sky-coins__item-text-em"
                    [innerHTML]="'label.paymentTotalAmountForCreditCard' | staticMsg"
                  >
                  </span>
                </dt>
                <dd class="c-flex-list01__contents">
                  <span class="c-amount c-amount--price p-sky-coins__item-text-em">
                    <span
                      class="c-amount__num c-amount__num--fs18"
                      [innerHTML]="
                        totalPrice
                          | amountFormat : undefined : (totalPriceCurrency !== '' ? totalPriceCurrency : undefined)
                      "
                    ></span>
                  </span>
                </dd>
              </div>
              <!-- ANA SKY コイン利用額 -->
              <div class="c-flex-list01__item c-flex-list01__item--sb c-flex-list01__item--center">
                <dt class="c-flex-list01__title u-payment-input-sky-coin-summary_max-width60">
                  <span
                    class="c-flex-list01__title-item p-sky-coins__item-text-em"
                    [innerHTML]="'label.amountOfSkyCoin.input' | staticMsg"
                  >
                  </span
                  ><span
                    class="c-flex-list01__title-item p-sky-coins__item-text-gray60"
                    [innerHTML]="'label.skyCoinRate' | staticMsg"
                  >
                  </span>
                </dt>
                <dd class="c-flex-list01__contents u-payment-input-sky-coin-summary_max-width60">
                  <span class="c-amount c-amount--price p-sky-coins__item-text-em">
                    <span
                      class="c-amount__num c-amount__num--fs18"
                      [innerHTML]="
                        totalUseCoinStatus === 'INVALID'
                          ? ('message.Incalculable' | staticMsg)
                          : (totalUseCoin
                            | amountFormat : undefined : (totalPriceCurrency !== '' ? totalPriceCurrency : undefined))
                      "
                    ></span>
                  </span>
                </dd>
              </div>
            </dl>
          </div>
          <div class="p-sky-coins__payment-foot">
            <dl class="c-flex-list01">
              <!-- クレジット支払い合計 -->
              <div class="c-flex-list01__item c-flex-list01__item--sb c-flex-list01__item--center">
                <dt class="c-flex-list01__title u-payment-input-sky-coin-summary_max-width60">
                  <span class="p-sky-coins__item-text-em" [innerHTML]="'label.paymentPlannedTotalAmount' | staticMsg">
                  </span>
                </dt>
                <dd class="c-flex-list01__contents u-payment-input-sky-coin-summary_max-width60">
                  <span class="c-amount c-amount--price p-sky-coins__item-text-em">
                    <span
                      class="c-amount__num c-amount__num--fs18"
                      [innerHTML]="
                        totalUseCoinStatus === 'INVALID'
                          ? ('message.Incalculable' | staticMsg)
                          : (totalCredit
                            | amountFormat : undefined : (totalPriceCurrency !== '' ? totalPriceCurrency : undefined))
                      "
                    ></span>
                  </span>
                </dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
